import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
import { useCountdown, pad } from '../hooks/useCountdown';
export function OfferBar() {
  const timeLeft = useCountdown(30);
  return <div className="bg-fil-terra text-white py-2.5 px-4" data-id="element-134" data-mp="p00w6gws4f09">
      <div className="flex items-center justify-center gap-2 sm:gap-3 flex-wrap text-[11px] sm:text-sm font-bold tracking-wide" data-id="element-135" data-mp="t2nrwswkmk2q">
        <span className="flex items-center gap-1.5" data-id="element-136" data-mp="fazf0nehzrkp">
          <FlameIcon size={14} className="shrink-0" data-id="element-137" data-mp="f96bhgz6lngx" />
          <span className="uppercase" data-id="element-138" data-mp="k30zgwltkolt">Oferta especial</span>
        </span>
        <span className="hidden sm:inline text-white/60" data-id="element-139" data-mp="5dcvfnm97bue">—</span>
        <span className="text-white/90 font-medium" data-id="element-140" data-mp="5b096y9gqfbj">Termina en</span>
        <span className="flex items-center gap-1 font-mono" data-id="element-141" data-mp="acy08eo3uef1">
          <motion.span key={`m-${timeLeft.minutes}`} initial={{
          scale: 1.12,
          opacity: 0.7
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.15,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-142" data-mp="3si145w2c4kdv">
            {pad(timeLeft.minutes)}
          </motion.span>
          <span className="text-white/60" data-id="element-143" data-mp="10y1768zfdhok">:</span>
          <motion.span key={`s-${timeLeft.seconds}`} initial={{
          scale: 1.12,
          opacity: 0.7
        }} animate={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.15,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white/20 rounded px-1.5 py-0.5 min-w-[28px] text-center" data-id="element-144" data-mp="10wq3e95zc9xg">
            {pad(timeLeft.seconds)}
          </motion.span>
        </span>
      </div>
    </div>;
}